<div class="user-panel">
  @if (menuMode !== 'list') {
    <div class="relative">
      <button (click)="dropdownOpen = !dropdownOpen"
              class="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-neutral-100 transition-colors">
        <div class="p-1.5 w-[34px] h-[34px] rounded-full bg-orange-500 flex items-center text-[18px] justify-center text-white font-medium">
          {{(loggedUser?.full_name ?? loggedUser?.user_name ?? '') | toNameImage}}
        </div>
        <span class="text-sm text-neutral-700">{{loggedUser?.full_name ?? loggedUser?.user_name}}</span>
      </button>
      @if (dropdownOpen) {
        <div class="absolute right-0 top-full mt-1 w-40 bg-white rounded-lg shadow-lg border border-neutral-200 py-1 z-50">
          @for (item of menuItems; track item.text) {
            <button (click)="onMenuItemClick(item); dropdownOpen = false"
                    class="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50 transition-colors">
              {{ item.text }}
            </button>
          }
        </div>
      }
    </div>
  } @else {
    <ul class="w-[130px]">
      @for (item of menuItems; track item.text) {
        <li (click)="onMenuItemClick(item)"
            class="px-3 py-2 text-sm text-neutral-700 hover:bg-neutral-50 cursor-pointer">{{ item.text }}</li>
      }
    </ul>
  }
</div>
